export const iconFontAwesomeDevicesHardwareHardDrive = (
	<i className="fa-solid fa-hard-drive"></i>
);
